import React from "react";
import { t } from "../../utils/i18n";

export const feedback = (props) => {
  if (props.verification_accepted) {
    return null;
  } else if (props.verification_started) {
    return (
      <div className="alert alert-warning verification-alert mt-4 font-weight-bold">
        <i className="fa fa-info-circle"></i> {t("account.verification.incomplete")}
      </div>
    );
  } else if (props.verification_pending) {
    return (
      <div className="alert alert-warning verification-alert mt-4 font-weight-bold">
        <i className="fa fa-info-circle"></i> {t("account.verification.pending")}
      </div>
    );
  } else if (props.verification_denied) {
    return (
      <div className="alert alert-warning verification-alert verification-alert-danger mt-4 font-weight-bold">
        {t("account.verification.denied")}
        <br />
        <span class="font-0_9 pb-4">
          {t("account.verification.denied_contact")}
        </span>
      </div>
    );
  }
};
